import BaseEndpoint from '@spa/apps/trustup-pro-base-js/endpoints/BaseEndpoint';
import OpportunityCollection from '../collections/OpportunityCollection';
import ActiveOpportunityCollection from '../collections/ActiveOpportunityCollection';
import ArchivedOpportunityCollection from '../collections/ArchivedOpportunityCollection';
import Opportunity from '../models/Opportunity';
import Worksite from '../models/Worksite';

export default class OpportunityEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'worksite',
            {
                'path': 'opportunities',
                'responseKey': 'opportunity',
                'responseKeyPlural': 'opportunities',
                'modelClass': Opportunity,
                'collectionClass': OpportunityCollection
            }
        );
    }

    async index(params = {})
    {
        let archived = params.archived || false;
        this.setCollectionClass(archived ? ArchivedOpportunityCollection : ActiveOpportunityCollection);
        let response = await super.index({archived});
        this.resetCollectionClass();
        return response;
    }

    async archive(uuid)
    {
        let data = {archived_at: window.moment().format('YYYY-MM-DD HH:mm:ss')};
        return await this.update({url: `${this.getPath()}/${uuid}/archive-status`, uuid, data});
    }

    async unarchive(uuid)
    {
        let data = {archived_at: null};
        return await this.update({url: `${this.getPath()}/${uuid}/archive-status`, uuid, data});
    }

    async updateStatus(uuid, status)
    {
        let data = {status};
        let response = await this.disableEvents().update({url: `${this.getPath()}/${uuid}/status`, uuid, data});
        this.enableEvents();
        return response;
    }

    async updateNotes(uuid, notes)
    {   
        let data = {notes};
        let response = await this.disableEvents().update({url: `${this.getPath()}/${uuid}/notes`, uuid, data});
        this.enableEvents();
        return response;
    }

    async updateContact(uuid, contact)
    {
        let data = {contact_uuid: contact};
        let response = await this.disableEvents().update({url: `${this.getPath()}/${uuid}/contact`, uuid, data});
        this.enableEvents();
        return response;
    }

    async updateTotalQuoted(uuid, total)
    {
        let data = {total: total};
        let response = await this.disableEvents().update({url: `${this.getPath()}/${uuid}/total-quoted`, uuid, data});
        this.enableEvents();
        return response;
    }

    async updateManagers(uuid, ids)
    {
        let data = {managers_id: ids};
        let response = await this.disableEvents().update({url: `${this.getPath()}/${uuid}/managers`, uuid, data});
        this.enableEvents();
        return response;
    }

    async addQuote(uuid, quote)
    {
        return await this.request(
            `${this.getPath()}/${uuid}/quotes`,
            'POST',
            {uuid: quote}
        );
    }

    async transformToWorksite(uuid)
    {
        let response = await this.request(
            `${this.getPath()}/${uuid}/worksites/transform`,
            'PUT'
        );

        console.log(response);
        return new Worksite(response.worksite);
    }

}